"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvirioMap = void 0;
var React = require("react");
var react_google_maps_1 = require("@120wateraudit/react-google-maps");
var EnvirioMapStyles_1 = require("./EnvirioMapStyles");
var EnvirioLocationMarkerClusterer_1 = require("./EnvirioLocationMarkerClusterer");
var EnvirioWindowMarkerClusterer_1 = require("./EnvirioWindowMarkerClusterer");
var EnvirioMap = /** @class */ (function (_super) {
    __extends(EnvirioMap, _super);
    function EnvirioMap() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getMapProps = function (bounds) {
            var _a = _this.props, markers = _a.markers, center = _a.center, defaultZoom = _a.defaultZoom;
            if (markers.length < 1) {
                return {
                    defaultZoom: defaultZoom === undefined ? 14 : defaultZoom,
                    defaultCenter: center
                };
            }
            if (markers.length === 1) {
                return {
                    zoom: 10,
                    center: markers[0].position
                };
            }
            return {
                ref: function (map) { return map && map.fitBounds(bounds); }
            };
        };
        _this.renderLayers = function (bounds) {
            var _a = _this.props, mapType = _a.mapType, markers = _a.markers, keyExtension = _a.keyExtension, renderInfoWindow = _a.renderInfoWindow;
            switch (mapType) {
                case 'normal':
                    return (React.createElement(EnvirioLocationMarkerClusterer_1.EnvirioLocationMarkerClusterer, { mapType: mapType, markers: markers, keyExtension: keyExtension, bounds: bounds }));
                case 'infoWindow':
                    return (React.createElement(EnvirioWindowMarkerClusterer_1.EnvirioWindowMarkerClusterer, { mapType: mapType, markers: markers, keyExtension: keyExtension, bounds: bounds, renderInfoWindow: renderInfoWindow }));
                case 'heatmap':
                    return (React.createElement(react_google_maps_1.HeatmapLayer, { options: {
                            gradient: EnvirioMapStyles_1.heatMapGradient,
                            radius: 20,
                            data: markers.map(function (m) {
                                var position = new google.maps.LatLng(m.position.lat, m.position.lng);
                                bounds.extend(position);
                                var location = {
                                    location: position,
                                    weight: 1
                                };
                                return location;
                            })
                        } }));
                default:
                    return null;
            }
        };
        return _this;
    }
    EnvirioMap.prototype.render = function () {
        var bounds = new google.maps.LatLngBounds();
        var _a = this.props, center = _a.center, keyExtension = _a.keyExtension, defaultZoom = _a.defaultZoom;
        return (React.createElement(react_google_maps_1.GoogleMap, __assign({}, this.getMapProps(bounds), { key: "GoogleMap" + JSON.stringify(center) + keyExtension, defaultOptions: {
                styles: EnvirioMapStyles_1.mapStyles
            }, defaultZoom: defaultZoom }), this.renderLayers(bounds)));
    };
    return EnvirioMap;
}(React.Component));
exports.EnvirioMap = EnvirioMap;
//# sourceMappingURL=EnvirioMap.js.map